module.exports = __webpack_public_path__ + "img/38.89e0ad0e.png";